module.exports = __webpack_public_path__ + "img/gocherm.0c4a2ef1.jpg";